<template>
	<div class="bg-grey-1 rounded-2xl mb-6">
		<div class="flex items-center gap-6 pt-6 pr-7 pl-7">
			<div class="text-gold">&#x2B24;</div>
			<div class="grow">
				<div class="text-xs mb-1">Contract</div>
				<div class="font-bold">{{ $store.getters.getContractConfigs(holding_prop.contract_id).name }}</div>
			</div>

			<div v-if="dataShown_prop == 'holding' && holding_prop.quantity != 0" class="text-theme text-xs cursor-pointer"
				@click="goToTradeHistory(holding_prop.contract_id)">
				Transaction History
			</div>

			<div v-if="dataShown_prop == 'holding'" class="flex gap-2">
				<button class="btn btn-small bg-green text-xs min-w-28 text-white"
					@click="updateTradeTicket(holding_prop.contract_id, 'buy')">

					<div class="flex justify-center">
						<div class="font-bold">Buy&nbsp;</div>
						<div class="font-medium">
							- {{ pricePerGramBuy(holding_prop.contract_id) }}
						</div>
					</div>
				</button>

				<button v-if="holding_prop.quantity != 0" class="btn btn-small bg-red text-xs min-w-28 text-white"
					@click="updateTradeTicket(holding_prop.contract_id, 'sell')">

					<div class="flex justify-center">
						<div class="font-bold">Sell&nbsp;</div>
						<div class="font-medium">
							- {{ pricePerGramSell(holding_prop.contract_id) }}
						</div>
					</div>
				</button>
			</div>
		</div>

		<div class="">
			<hr class="border-3 border-transparent border-grey-4 my-6">
		</div>

		<div class="flex items-center gap-6 pr-7 pb-6 pl-7">
			<div class="grow">
				<div class="flex items-center gap-2 text-sm mb-2">
					<div>
						{{ dataShown_prop == 'holding' ? 'Contract Holding Value' : 'Amount Received' }}
					</div>

					<div v-if="$store.getters.paymentMethod == 'gopay'" class="bg-white rounded-full leading-4 cursor-pointer p-1"
						@click="$store.commit('goldBalanceNew/setShowHolding', !showHolding_prop)">
						<IconEyeClose v-if="showHolding_prop" width_prop="1rem" heigth_prop="1rem" :color_prop="hexColorTheme">
						</IconEyeClose>
						<IconEyeOpen v-else width_prop="1rem" heigth_prop="1rem" :color_prop="hexColorTheme"> </IconEyeOpen>
					</div>

					<div v-if="$store.getters.paymentMethod == 'gopay'" class="bg-white rounded-full leading-4 aspect-square p-1">
						<Tooltip v-if="dataShown_prop == 'holding'" type_prop="3" textAlign_prop="left" maxWidth_prop="max-w-150">
							<div class="text-base font-bold mb-2">Contract Holding Value</div>
							<div class="font-normal mb-6">
								The amount that would be received if the gold in the contract were sold at the current selling price
								(updated every 3 seconds). This also includes estimated profit & loss data in Rupiah/Dollar and
								percentage.
							</div>

							<div class="text-base font-bold mb-2">Total Profit & Loss</div>
							<div class="font-normal">
								The total realized profit/loss from all sold gold (all contracts), shown in Rupiah/Dollar and
								percentage. The profit calculation uses the LIFO (Last In, First Out) method.
								Total Profit & Loss is displayed in 'green' if in profit, and in 'red' if at a loss.
							</div>
							<div class="font-normal text-gold mb-6">
								Note: Admin fees are not included in the profit and loss calculation.
							</div>

							<div class="text-base font-bold mb-2">Gold Withdrawal Reserved</div>
							<div class="font-normal mb-6">
								The amount of gold that has been allocated or separated from the user's total main gold holdings because
								it is currently undergoing withdrawal or delivery processing.
							</div>

							<div class="text-base font-bold mb-2">In Buy Process & In Sell Process</div>
							<div class="font-normal mb-1">
								In Buy Process - The amount (in grams) of gold that is still open / in process / unmatched for a buy
								order.
							</div>
							<div class="font-normal mb-6">
								In Sell Process - The quantity of gold that is still open / in process / unmatched for a sell order.
							</div>
						</Tooltip>

						<Tooltip v-else textPosition_prop="bottom" textAlign_prop="left" maxWidth_prop="max-w-150">
							<div class="text-base font-bold mb-2">Total Amount Received</div>
							<div class="font-normal mb-6">
								The amount received from gold sales that have been successfully sold.
							</div>

							<div class="text-base font-bold mb-2">Total Realized Profit & Loss</div>
							<div class="font-normal">
								The total realized profit/loss from all sold gold, shown in Rupiah/Dollar and
								percentage. The profit calculation uses the LIFO (Last In, First Out) method.
								Total Profit & Loss is displayed in 'green' if in profit, and in 'red' if at a loss.
							</div>
							<div class="font-normal text-gold mb-6">
								Note: Admin fees are not included in the profit and loss calculation.
							</div>
						</Tooltip>
					</div>
				</div>

				<div v-if="!showHolding_prop" class="text-3.5xl">
					{{ currencySymbol }}&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
				</div>

				<!-- Unrealized Contract -->
				<div v-else-if="dataShown_prop == 'holding'" @click="debug(holding_prop)">
					<div class="text-3.5xl mb-2">
						{{ metalValueAtDateNewShown(holding_prop.contract_id, holding_prop.remaining_quantity) }}
					</div>

					<div
						:class="`text-sm ${unrealizedPnlShown(holding_prop).includes('-') ? 'text-danger' : unrealizedPnlShown(holding_prop).includes('+') ? 'text-success' : 'text-white'}`">
						{{ unrealizedPnlShown(holding_prop) }}
						{{ unrealizedPnlPercentageShown(holding_prop) }}
					</div>
				</div>

				<!-- Realized Contract-->
				<div v-else class="">
					<div class="text-3.5xl mb-2">
						{{ nominalDiterimaShown(holding_prop) }}
					</div>
					<div
						:class="`text-sm ${realizedPnlShown(holding_prop).includes('-') ? 'text-danger' : realizedPnlShown(holding_prop).includes('+') ? 'text-success' : 'text-white'}`">
						{{ realizedPnlShown(holding_prop) }} {{ realizedPnlPercentageShown(holding_prop) }}
					</div>
				</div>

			</div>

			<div v-if="dataShown_prop == 'holding'" class="flex gap-6">
				<div class="text-sm">
					<div class="mb-2">Gold Grams</div>

					<div v-if="showHolding_prop">
						{{ holding_prop.remaining_quantity }} g
					</div>
					<div v-else>
						&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
					</div>
				</div>

				<div class="text-sm">
					<div class="mb-2">Quantity</div>

					<div v-if="showHolding_prop">
						{{ holding_prop.remaining_units }}
					</div>
					<div v-else>
						&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
					</div>
				</div>

				<div class="text-sm">
					<div class="mb-2">Gold Withdrawal Reserved</div>

					<div v-if="showHolding_prop">
						{{ holding_prop.withdrawal_process }} g
					</div>
					<div v-else>
						&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
					</div>
				</div>

				<div class="text-sm">
					<div class="mb-2">In Buy Process</div>

					<div v-if="showHolding_prop">
						{{ holding_prop.buy_process }} g
					</div>
					<div v-else>
						&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
					</div>
				</div>

				<div class="text-sm">
					<div class="mb-2">In Sell Process</div>

					<div v-if="showHolding_prop">
						{{ holding_prop.sell_process }} g
					</div>
					<div v-else>
						&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
					</div>
				</div>
			</div>

			<div v-else class="flex gap-6">
				<div class="text-sm">
					<div class="mb-2">Gold Grams Sold</div>

					<div v-if="showHolding_prop">
						{{ holding_prop.sold_quantity }} g
					</div>
					<div v-else>
						&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
					</div>
				</div>
			</div>
		</div>

		<!-- POCKETS -->
		<div v-if="holding_prop.pockets.length > 1" class="flex gap-6 pr-7 pb-6 pl-7">
			<div v-for="pocket in holding_prop.pockets" @key="`pocket${pocket.contract_id}${pocket.type}`"
				@click="debug(pocket, 'pocket')" class="basis-2/4 bg-grey-2 rounded-2xl">
				<div class="text-xs pt-5 pr-6 pl-6">{{ pocketName(pocket.contract_id, pocket.type) }}</div>

				<div class="">
					<hr class="border-3 border-grey-1 my-5">
				</div>

				<!-- Unrealized Pocket -->
				<div v-if="dataShown_prop == 'holding'" class="pr-6 pb-5 pl-6">
					<div class="text-xs mb-2">Pocket Holding Value</div>

					<div v-if="showHolding_prop" class="text-sm font-medium mb-4">
						<div class="mb-1">
							{{ metalValueAtDateNewShown(pocket.contract_id, pocket.remaining_quantity) }}
						</div>

						<div
							:class="`text-xs ml-1 ${unrealizedPnlShown(pocket).includes('-') ? 'text-danger' : unrealizedPnlShown(pocket).includes('+') ? 'text-success' : 'text-white'}`">
							{{ unrealizedPnlShown(pocket) }}
							{{ unrealizedPnlPercentageShown(pocket) }}
						</div>
					</div>

					<div v-else class="text-sm font-medium mb-4">
						{{ currencySymbol }}&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
					</div>

					<div class="flex gap-6">
						<div class="text-xs">
							<div class="mb-2">Gold Grams</div>

							<div v-if="showHolding_prop">
								{{ pocket.remaining_quantity }} g
							</div>
							<div v-else>
								&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
							</div>
						</div>

						<div class="text-xs">
							<div class="mb-2">Quantity</div>

							<div v-if="showHolding_prop">
								{{ pocket.remaining_units }}
							</div>
							<div v-else>
								&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
							</div>
						</div>

						<div class="text-xs">
							<div class="mb-2">In Buy Process</div>

							<div v-if="showHolding_prop">
								{{ pocket.buy_process }} g
							</div>
							<div v-else>
								&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
							</div>
						</div>

						<div class="text-xs">
							<div class="mb-2">In Sell Process</div>

							<div v-if="showHolding_prop">
								{{ pocket.sell_process }} g
							</div>
							<div v-else>
								&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
							</div>
						</div>
					</div>
				</div>

				<!-- Realized Pocket-->
				<div v-else class="gap-6 pr-6 pb-5 pl-6">
					<div class="text-xs mb-2">Amount Received</div>

					<div class="flex justify-between ">
						<div class="">

							<div v-if="showHolding_prop" class="text-sm">
								<div class="mb-1">
									{{ nominalDiterimaShown(pocket) }}
								</div>

								<div
									:class="`text-xs ml-1 ${realizedPnlShown(pocket).includes('-') ? 'text-danger' : realizedPnlShown(pocket).includes('+') ? 'text-success' : 'text-white'}`">
									{{ realizedPnlShown(pocket) }} {{ realizedPnlPercentageShown(pocket) }}
								</div>
							</div>

							<div v-else class="text-sm">
								{{ currencySymbol }}&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
							</div>
						</div>

						<div class="text-xs">
							<div class="mb-2">Gold Grams Sold</div>

							<div v-if="showHolding_prop">
								{{ pocket.sold_quantity }} g
							</div>
							<div v-else>
								&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
							</div>
						</div>
					</div>

				</div>

			</div>
		</div>

	</div>
</template>

<script>
import { Decimal } from 'decimal.js'

import Alert from '../../alert-component/AlertComponent'

import holdingsMixin from '@/composable/holdingsMixin.js'

import Utils from '@/utils/index.js'

import Loader from '@/components/Loader.vue'
import TradeTicket from '@/components/TradeTicket.vue'
import IconEyeClose from '../../icons/IconEyeClose.vue'
import IconEyeOpen from '../../icons/IconEyeOpen.vue'
import Tooltip from '../../Tooltip.vue'

export default {
	name: 'HoldingContract',

	mixins: [holdingsMixin],

	props: {
		holding_prop: {
			type: Object,
			required: true,
		},
		dataShown_prop: {
			type: String,
			required: true,
		},
		showHolding_prop: {
			type: Boolean,
			default: true,
		},
	},

	components: {
		Loader,
		TradeTicket,
		IconEyeClose,
		IconEyeOpen,
		Tooltip
	},

	data() {
		return {
			hexColorTheme: getComputedStyle(document.documentElement).getPropertyValue('--color-theme'),
		}
	},

	computed: {

	},

	methods: {
		pricePerGramBuy(contractId) {
			const golds = this.$store.state.golds

			if (!golds) {
				return -1
			}

			const tempGold = golds[contractId]
			if (!tempGold) {
				return -1
			}

			const depthTTDecimalPlaces = this.$store.state.contractConfigs[contractId].depthTTDecimalPlace

			if (this.currency == 'idr') {
				return Utils.currencyFormat(Decimal.mul(tempGold.buy, this.streamingRate.streamBuy).toFixed(depthTTDecimalPlaces), 'idr')
			}

			return Utils.currencyFormat(new Decimal(tempGold.buy).toFixed(depthTTDecimalPlaces))
		},
		pricePerGramSell(contractId) {
			const golds = this.$store.state.golds

			if (!golds) {
				return -1
			}

			const tempGold = golds[contractId]
			if (!tempGold) {
				return -1
			}

			const depthTTDecimalPlaces = this.$store.state.contractConfigs[contractId].depthTTDecimalPlace

			if (this.currency == 'idr') {
				return Utils.currencyFormat(Decimal.mul(tempGold.sell, this.streamingRate.streamSell).toFixed(depthTTDecimalPlaces), 'idr')
			}

			return Utils.currencyFormat(new Decimal(tempGold.sell).toFixed(depthTTDecimalPlaces))
		},

		pocketName(contractId, type) {
			const contractName = this.$store.getters.getContractConfigs(contractId).name

			if (type.toLowerCase() == 'trade') {
				return 'Main Pocket ' + (contractName ? contractName : '')
			} else if (type.toLowerCase() == 'gtmu') {
				return 'Pocket ' + (contractName ? ` ${contractName}` : '') + ' - Gold to Mecca'
			} else {
				return 'Pocket'
			}
		},

		updateTradeTicket(contractId, direction) {
			// if user press sell button, but the account is not linked to gopay, then guide user to buy
			if (this.$store.getters.paymentMethod == 'gopay' && !this.$store.getters.isGopayLinked && direction == 'sell') {
				Alert.open({
					type: 'confirm',
					title: 'Tidak Terhubung dengan Metode Pembayaran',
					description: 'Akun JFXGOLD X Anda tidak terhubung dengan metode pembayaran yang dipilih. Lakukan order beli terlebih dahulu untuk melanjutkan proses',
					buttonConfirmText: 'Beli Emas',
					buttonDeclineText: 'Tutup',
					buttonConfirmPosition: 'vertical',
					onConfirm: () => {
						this.$emit('update-trade-ticket', contractId, 'buy')
					},
				})

				return
			}

			this.$emit('update-trade-ticket', contractId, direction)
		},

		goToTradeHistory(contractIdParam) {
			this.$store.commit('setFilterContractTransactions', [contractIdParam])
			this.$store.commit('setReportToShow_mut', 'transactions')
		},

		// for QA to debug
		debug(holding) {
			const contractId = holding.contract_id
			const remainingGram = holding.remaining_quantity
			const pocketType = holding.type // only for pocket

			const nilaiHolding = this.countMetalValueAtDateNew(contractId, remainingGram)
			const unrealizedPnl = this.countUnrealizedPnl(holding)

			console.log('🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲', '\n',
				'Contract ID:', contractId, '\n',
				'Contact Name:', this.$store.getters.getContractConfigs(contractId).name, '\n',
				'Price Per Gram SELL USD:', this.pricePerGramSellUsd(contractId), '\n',

				'Nilai Holding:', nilaiHolding, '\n',
				'Unrealized PnL:', unrealizedPnl, '\n',
				'Toal BUY Price:', Decimal.sub(nilaiHolding, unrealizedPnl).toFixed(), '\n',
				'Percentage Unrealized PnL:', this.unrealizedPnlPercentageShown(holding), '\n',
				'🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲🪲', '\n',
			)

		},
	}
}
</script>

<style scoped></style>